import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'booleanPipe',
    standalone: false
})
export class BooleanPipe implements PipeTransform {
  transform(data: string | boolean): string
  {
    return data ? "Ano" : "Ne";
  }
}
